<template>
  <div>
    <form-field-select
      label="Type"
      :disabled="form.id !== undefined"
      v-model="form.type"
      :validation-errors="validationErrors.type"
    >
      <option :value="ENUMS.FollowUpSequenceStepTypeEnum.Task.value">{{ENUMS.FollowUpSequenceStepTypeEnum.Task.label}}</option>
      <option :value="ENUMS.FollowUpSequenceStepTypeEnum.Email.value">{{ENUMS.FollowUpSequenceStepTypeEnum.Email.label}}</option>
      <option :value="ENUMS.FollowUpSequenceStepTypeEnum.Text.value">{{ENUMS.FollowUpSequenceStepTypeEnum.Text.label}}</option>
      <option :value="ENUMS.FollowUpSequenceStepTypeEnum.SendWebhook.value">{{ENUMS.FollowUpSequenceStepTypeEnum.SendWebhook.label}}</option>
    </form-field-select>
    <template v-if="validationErrors.type">
      <p class="form_field--errors mt-0 mb-100">Setup email integration inside <router-link :to="{name: 'settings', params: {tab: 'email'}}">Email Settings</router-link>.</p>
    </template>

    <form-field-input
        label="Task"
        v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value"
        v-model="form.label"
        :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-input
      label="Day Offset"
      v-model.number="form.day_offset"
      type="number"
      :validation-errors="validationErrors.day_offset"
    ></form-field-input>

    <form-field-time-picker
      label="Time"
      v-model="form.time"
      type="time"
      :validation-errors="validationErrors.time"
    ></form-field-time-picker>

    <form-field-editor
      ref="subjectField"
      label="Subject"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Email.value"
      v-model="form.subject"
      type="shortCodesOnly"
      is-single-line
      short-code-type="followUp"
      :validation-errors="validationErrors.subject"
    ></form-field-editor>


    <!-- Text Field-->
    <form-field-editor
        label="Body"
        v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Text.value"
        v-model="form.body"
        :validation-errors="validationErrors.body"
        type="textContactWithRecord"
        short-code-type="followUp"
    ></form-field-editor>

    <!-- Email Field-->
    <form-field-editor
      label="Body"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Email.value"
      v-model="form.body"
      :validation-errors="validationErrors.body"
      type="email"
      short-code-type="followUp"
      @email-snippet-selected="handleEmailSnippet"
    ></form-field-editor>

    <form-field-textarea
      label="Description"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <form-field-input
      label="Task Link"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value"
      v-model="form.link"
      :validation-errors="validationErrors.link"
      help-text="Link to video or docs on how to do the task"
    ></form-field-input>

    <form-field-input
      v-if="form.type === ENUMS.FollowUpSequenceStepTypeEnum.SendWebhook.value"
      label="What URL should we send the lead data to?"
      type="url"
      v-model="form.webhook_url"
      :validation-errors="validationErrors.webhook_url"
    ></form-field-input>

    <form-field-select
      label="User Role"
      v-model="form.user_role"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value"
      :validation-errors="validationErrors.user_role"
      help-text="If the selected role is not set on the record, then this fallback user will be set instead"
    >
      <option :value="null">Not Set</option>
      <option v-for="role in userRoles" :value="role.value">{{role.label}}</option>
    </form-field-select>

    <form-field-select
      label="Assign To"
      v-model="form.assign_to_id"
      v-show="form.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value"
      :validation-errors="validationErrors.assign_to_id"
    >
      <option :value="null">not assigned to a user</option>
      <option v-for="user in $store.getters.activeUsers" :value="user.id">{{user.full_name}}</option>
    </form-field-select>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "FollowUpSequenceStepTemplateForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        userRoles: ENUMS.UserRoleEnum,
        form: {},
        validationErrors: {},
        defaultForm: {
            market_id: this.$store.getters.market.id,
            FUS_template_id: null,
            type: ENUMS.FollowUpSequenceStepTypeEnum.Task.value,
            day_offset: 1,
            time: '08:00',
            subject: '',
            body: '',
            description: '',
            link: '',
            label: '',
            webhook_url: '',
            assign_to_id: null,
        },
      }
    },
    watch: {
      'form.type'(newValue) {
        if (newValue === ENUMS.FollowUpSequenceStepTypeEnum.Email.value && !this.isEmailIntegrated) {
          this.validationErrors.type = 'You can not create an email template without a email integration.';
          return
        }
        this.validationErrors = {}
      },
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      isEmailIntegrated() {
        return this.$store.getters.emailIsIntegrated
      }
    },
    methods: {
      handleEmailSnippet(snippet) {
        this.form.subject = snippet.subject
      },
      update() {
        return this.$api.fusStepTemplates.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Follow Up Sequence Step was updated',
              type: 'is-success'
            });

            return res;
          });
      },
      create() {
        return this.$api.fusStepTemplates.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Follow Up Sequence Step was created',
              type: 'is-success'
            });

            return res;
          });
      },
      delete() {
        return this.$api.fusStepTemplates.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Follow Up Sequence Step was archived',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
